import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ENVIRONMENT_PROVIDER } from '@mkp/shared/util-environment';
import { Observable } from 'rxjs';
import { SendVerificationEmailBody } from './send-verification-email.dto';
import { SendVerificationEmailMapper } from './send-verification-email.mapper';

@Injectable({
  providedIn: 'root',
})
export class SendVerificationEmailApi {
  private http = inject(HttpClient);
  private mapper = inject(SendVerificationEmailMapper);
  private readonly apiCore = inject(ENVIRONMENT_PROVIDER).api.core;

  sendVerificationEmail(userId: string): Observable<void> {
    const body: SendVerificationEmailBody = this.mapper.toBody(userId);
    return this.http.post<void>(`${this.apiCore}/user/${userId}/send-verification-email`, body);
  }
}
